<template>
    <b-modal id="bygginv-modal" :title="popup.title" size="xl" hide-footer scrollable>
        <template v-slot:modal-title>
            <h5 class="modal-title">{{ popup.title }}</h5>
            <h6 v-if="popup.subtitle" class="modal-subtitle">{{ popup.subtitle }}</h6>
        </template>
        <div class="row">
            <div class="col-12 font-italic text-grey">
                Värderingen bygger på byggnadsinventeringar som är gjorda i samarbetsprojekt mellan Länsstyrelsen i Västmanlands län,
                Västmanlands läns museum och respektive kommun. Läs mer på:
                <a href="https://kulturarvvastmanland.se/kulturmiljounderlag/">Kulturmiljöunderlag</a>
            </div>
            <div class="col-12 col-sm-4 mt-3" v-if="popup.modal.properties.byggnadstyp">
                <h5>Byggnadstyp</h5>
                {{ popup.modal.properties.byggnadstyp }}
            </div>
            <div class="col-12 col-sm-4 mt-3" v-if="popup.modal.properties.nuvarande_funktion">
                <h5>Nuvarande funktion</h5>
                {{ popup.modal.properties.nuvarande_funktion }}
            </div>
            <div class="col-12 col-sm-4 mt-3" v-if="popup.modal.properties.tidigare_funktion1 || popup.modal.properties.tidigare_funktion2">
                <h5>Tidigare funktion</h5>
                {{ popup.modal.properties.tidigare_funktion1 }}
                {{ popup.modal.properties.tidigare_funktion2 }}
            </div>
            <div class="col-12 col-sm-4 mt-3" v-if="popup.modal.properties.byggar_start || popup.modal.properties.byggar_slut">
                <h5>Byggår</h5>
                {{ popup.modal.properties.byggar_start }} - {{ popup.modal.properties.byggar_slut }}
            </div>
            <div class="col-12 mt-3" v-if="popup.modal.properties.allman_info">
                <h5>Allmän info</h5>
                {{ popup.modal.properties.allman_info }}
            </div>
            <div class="col-12 mt-3" v-if="popup.modal.properties.beskrivning">
                <h5>Beskrivning</h5>
                {{ popup.modal.properties.beskrivning }}
            </div>
            <div class="col-12 mt-3" v-if="popup.modal.properties.historik">
                <h5>Historik</h5>
                {{ popup.modal.properties.historik }}
            </div>
            <div class="col-12 mt-3" v-if="popup.modal.properties.vardebeskrivning">
                <h5>Värdebeskrivning</h5>
                {{ popup.modal.properties.vardebeskrivning }}
            </div>
            <div class="col-12 mt-3" v-if="popup.modal.properties.viktiga_karaktarsdrag">
                <h5>Viktiga karaktärsdrag</h5>
                {{ popup.modal.properties.viktiga_karaktarsdrag }}
            </div>
            <div class="col-12 mt-3" v-if="popup.modal.properties.rad_och_rekommendationer">
                <h5>Råd och rekommendationer</h5>
                {{ popup.modal.properties.rad_och_rekommendationer }}
            </div>
            <div class="col-12 mt-3" v-if="popup.modal.properties.gardsbeskrivning">
                <h5>Gårdsbeskrivning</h5>
                {{ popup.modal.properties.gardsbeskrivning }}
            </div>
        </div>
        <b-container fluid class="mt-5">
            <image-gallery id="yada" :images="this.images" byggnadsinfo="true"></image-gallery>
        </b-container>
    </b-modal>
</template>

<script>
import axios from 'axios'
import { center } from '@turf/turf'
export default {
  props: ['popup'],

  data () {
    return {
      images: []
    }
  },

  mounted () {

  },

  methods: {
    fetchBilder (coords) {
      const bbox = [
        coords[0],
        coords[1],
        coords[0] + 0.000001,
        coords[1] + 0.000001,
        'EPSG:3857'
      ]
      axios.get('https://vlmgeo.ltv.se/geoserver/kulturarv/wfs', {
        params: {
          service: 'wfs',
          version: '1.1.0',
          request: 'GetFeature',
          outputFormat: 'json',
          srsname: 'EPSG:3857',
          bbox: bbox.join(),
          typeName: 'view_kulturarv_bilder_vasteras'
        }
      })
        .then(response => response.data)
        .then(data => {
          const images = _.map(_.get(data, 'features'), feature => ({
            id: feature.properties.id,
            path: feature.properties.url_bild
          }))
          this.images = images
        })
    }
  },

  computed: {
    modalVisible () {
      return this.showModal
    }
  },

  watch: {
    popup (newVal) {
      if (newVal) {
        const c = center(this.popup.modal)
        const coords = _.get(c, 'geometry.coordinates')

        this.fetchBilder(coords)
      }
    }
  }
}
</script>
